// Api name must start with '/' in apiVersioningConfigs e.g. dashboard/data = "/dashboard/data"
// VARIABLES USED FOR GENERIC APIs :-
//1. :id = for identifying id in api e.g. listId in listData i.e;/listRenderer/list/342/listdata = /listRenderer/list/:id/listdata
//2. :entity = for identifying apis used for multiple entities e.g. tblusers in tblusers/show i.e;/tblusers/show1382 = :entity/show
//3. :action is for /api/v1/todo/entity/order/ api only.
//4. _ added to version will add the version at the beginning of the API url.

var apiVersioning =  {
    apiVersioningConfigs :  {
        "/dashboard/records":"v3_",
        "/dashboard/records/totalCount":"v3_",
        "/dashboard/listWidgetData/:id": "v3_",
        "/dashboard/data":"",
        "/dashboard/entityListingWidgetMetadata/":"",
        "/dashboard/entity-charts":"",
        "/dashboard/slExecutivedata":"",
        "/dashboard/analysis":"",
        "/dashboardview/list/:id":"",
        "/show/:entity":"",
        "/dashboardview/delete/:id":"",
        "/dashboardview/save":"",
        "/dashboardview/update":"",
        "/userSearchHistory/list":"",
        "/userActivityTracker/list":"",
        "/api/v1/todo/pending/task/:id":"",
        "/api/v1/todo/pending/approval/:id": "",
        "/api/v1/todo/entity/order/:action":"",
        "/api/v1/todo/entitytypetolistid": "",
        "/api/v1/todo/status/color":"",
        "/v1/sideLayout/headerbar":"",
        "/todo/daily/count": "",
        "/todo/daily":"",
        "/todo/weekly": "",
        "/todo/dailymeetings":"",
        "/todo/daily/task/approval": "",
        "/tblusers/home/page":"",
        "/tblusers/home/page/create":"",
        "/tblusers/home/page/update":"",
        "/tblusers/home/page/delete":"",
        "/tblusers/dashboard/widget/type":"",
        "/documentviewer/show/" : "",
        "/v2/summarydata" : "",
        "/vendors/show" : "v2_",
        "/vendors/edit" : "v2_",
        "/vendors/partial-edit": "v2_",
        "/listRenderer/list/:id/filterData" : "",
        "/listRenderer/list/:id/defaultUserListMetaData" : "",
        "/listRenderer/list/:id/listdata": "v3_",
        "/reportRenderer/list/:id/listdata": "v3_",
        "/listRenderer/list/:id/tablistdata":"",
        "/listRenderer/list/:id/tablistdata/:id/:id": "v3_",
        "/show/tblcontracttemplate/first/:id":"",
        "/:entity/show" : "",
        "/:entity/create" : "",
        "/:entity/clone" : "",
        "/:entity/edit" : "",
        "/delegation/create-form" : "v3",
        "/bulkaction/save" : "",
        "/tblcontractdocuments/getentities/:id/:id":"V1",
        "/autoextraction/dashboards/data": "v1",
        "/options/workflow": "v1_",
        "/listRenderer/list/:id/scheduledata/:id": "v3_",
        "/authHelper/getAccessToken": "v1_"
    },
    createApiVersioningUrl : function (url) {
        if (url && url.indexOf(".html") == -1 && url.indexOf(".js") == -1) {
            if (url.indexOf(window.location.origin) > -1) {
                url = url.replace(window.location.origin, "");
            }
            var mapper = "";
            var tempUrl = url.split("?")[0];
            if (tempUrl.indexOf(window.location.origin) > -1) {
                tempUrl = tempUrl.replace(window.location.origin, "");
            }
            var splitUrl = tempUrl.split("/");
            var pageType = ['show' ,'edit' , 'create' , 'clone', 'partial-edit'];
            if (splitUrl[2] && pageType.indexOf(splitUrl[2]) > -1) {
                mapper = this.apiVersioningConfigs["/:entity/" + splitUrl[2]] || this.apiVersioningConfigs["/" + splitUrl[1] + "/" + splitUrl[2]];
            } else {
                if (tempUrl.indexOf("/api/v1/todo/entity/order/") > -1 ) {
                    tempUrl = tempUrl.replace(splitUrl[splitUrl.length - 1], ":action");
                } else if (tempUrl.search(/\d/) > -1) {
                    splitUrl =  splitUrl.map( function (obj) {
                        if(!isNaN(parseInt(obj))) {
                            obj = ":id";
                        }
                        return obj;
                    });
                    tempUrl = splitUrl.join("/");
                }
                mapper = this.apiVersioningConfigs[tempUrl];
            }
            if(mapper && mapper != "" && mapper.indexOf("_") > -1){
                mapper = mapper.replace("_", "");
                if (url.split("?")[1]) {
                    url = '/' + mapper + url.split("?")[0] + "?" + url.split("?")[1];
                } else {
                    url = '/' + mapper + url + '/';
                }
            } else if (mapper && mapper != "") {
                if (url.split("?")[1]) {
                    url = url.split("?")[0] + '/' + mapper + "?" + url.split("?")[1];
                } else {
                    url = url + '/' + mapper;
                }
            }
        }
        if(url.indexOf("options") && url.indexOf("=NaN")>-1) {
            url = url.replace(/NaN/g,"");
        }
        return url;
    },
    getApiDynamicVersion: function (key, id, extraListParameter, url) {
        let API = "";
        switch (key) {
            case "listData":
                API = "/listRenderer/list/" + id + "/listdata?version=2.0";
                if (extraListParameter) {
                    let {contractId, relationId, vendorId} = window;
                    if (extraListParameter.firstCall) {
                        API = API + "&isFirstCall=true"
                    }
                    API = API + `&contractId=${contractId}&relationId=${relationId}&vendorId=${vendorId}&am=true`;
                }
                break;
            case "reportRenderer_listData":
            case "reportRenderer":
                API = "/reportRenderer/list/" + id + "/listdata";
                break;
            case "reportRenderer_save":
                API = "/reportRenderer/list/"+ id + "/userpreferences/save";
                break;
            case "listRenderer_save":
                API = "/listRenderer/list/"+ id + "/userpreferences/save";
                break;
            case "reportRenderer_userListMetaData":
                API = "/reportRenderer/list/" + id;
                break;
            case "listRenderer_userListMetaData":
                API = "/listRenderer/list/" + id;
                break;
            case "reportRenderer_update":
                API = "/reportRenderer/list/" + id;
                break;
            case "listRenderer_update":
                API = "/listRenderer/list/" + id;
                break;
            case "reportRenderer_userDefault":
                API = "/reportRenderer/list/" + id;
                break;
            case "listRenderer_userDefault":
                API = "/listRenderer/list/" + id;
                break;
            case "reportRenderer_userPreference":
                API = "/reportRenderer/list/" + id;
                break;
            case "listRenderer_userPreference":
                API = "/listRenderer/list/" + id;
                break;
            case "reportRenderer_deletePreference":
                API = "/reportRenderer/list/" + id;
                break;
            case "listRenderer_deletePreference":
                API = "/listRenderer/list/" + id;
                break;
            case "createlinks":
                API = "/v4/ux/createlinks/";
                break;
            case "summarydata":
                API = "/v4/ux/summarydata/";
                break;
            case "actions":
                API = "/v4/ux/wf-actions/";
                break;
            case "summarylayout":
                API = "/v4/ux/summarylayout/";
                break;
            case "action":
                API = "/v4/ux/actions/";
                break;
            case "listRenderer_filterController":
            case "listRenderer_commonUtil":
            case "listRenderer_urlFactory":
            case "listRenderer":
                API = "/v2/listRenderer/list/";
                break;
            case "listRenderer_filterController_new":
                API = "/v3/listRenderer/list/";
                break;
            case "reportRenderer_reportController":
            case "reportRenderer":
                API = "/v2/reportRenderer/list/";
                break;
            case "reportRenderer_preferenceDirective":
                API = "/v2/reportRenderer/";
                break;
            case "listRenderer_preferenceDirective":
                API = "/v2/listRenderer/";
                break;
            case "/shortcuts":
                API = "/shortcuts/allSections";
                break;
            case "bypass_TemplateWizard":
                API = "/cdr/"+id+"/"+extraListParameter+"/v1/executeTemplateWizard";
                break;
            case "delegation_createForm":
                API = `/delegation/create-form/v4${id? `?fromUserId=${id}`:''}`;
                break;
            case "filterData":
                API = `/v3/listRenderer/list/${id}/filterData?relationId=&contractId=&am=true&insightComputationId=`;
               break;
            case "fieldHistory":
                API = "/tblauditlogs/fieldHistory/v2/" + id + "/" + extraListParameter;
                break;
            default:
                console.warn("Key not found");
                break;
        }
        return API;
    },
    getFieldHistoryVersionedUrl: function (url) {
        if (!url || typeof url !== 'string') return url;
        if (url.indexOf('fieldHistory/v2') !== -1 || url.indexOf('fieldHistory/v3') !== -1) return url;
        var match = url.match(/fieldHistory\/(\d+)\/(\d+)/);
        if (match) {
            var version = 'v2';
            return url.replace(/fieldHistory\/(\d+)\/(\d+)/, 'fieldHistory/' + version + '/$1/$2');
        }
        return url;
    }
}


